import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-create-learnset',
  templateUrl: './create-learnset.component.html',
  styleUrls: ['./create-learnset.component.scss'],
  standalone: false
})
export class CreateLearnsetComponent {

  @Input() courseId?: number;
  @Output() learnsetCreationFinished: EventEmitter<any> = new EventEmitter<any>();

  form!: FormGroup;
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private learnsetService: LearnsetService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  saveLearnset() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    const learnset = new Learnset(null, null, this.form.value.name, this.courseId!, 0, 0, [], null, true);
    this.learnsetService.saveLearnset(learnset).subscribe((result) => {
      this.isLoading = false;
      this.form.reset();
      this.learnsetCreationFinished.emit();
    });
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
